import aes from 'crypto-js/aes';
import { login } from '../api/auth'
import * as types from './types';

const LOGIN_SECRET_TOKEN = '9WWwhO7ll7Np9QrKZ7iEM1cF9gdvmagn';

const request = () => {
  return {
    type: types.REQUEST,
    payload: true,
  }
}

const success = payload => {
  return {
    type: types.SUCCESS,
    payload
  }
}

const error = error => {
  return {
    type: types.ERROR,
    payload: error,
  }
}

const logOut = () => {
  return {
    type: types.LOG_OUT
  }
}

const validateToken = headers => {
  return {
    type: types.VALIDATE_TOKEN,
    headers
  }
}

const loginAction = ({ customer, email, password }) => {  
  return dispatch => {
    dispatch(request());    
    const passphrase = aes.encrypt(password, customer.concat(LOGIN_SECRET_TOKEN).split('').reverse().join('')).toString();
    login({ customer, email, passphrase })
      .then((res) => {
        Promise.all([
          dispatch(validateToken({ 'Authorization': res.data }))
        ]).then(() => {          
          dispatch(success(res.data));
        });       
    }).catch(({ response }) => {
      dispatch(error(response.data.error))
    });
  }
};

const authCheckState = () => {
  return dispatch => {
      const token = localStorage.getItem('Authorization');
      if (!token) {
          dispatch(logOut());
      } else {
        dispatch(success(token));
      }
  };
};

const logoutAction = () => { 
  return dispatch => {
    dispatch(success(null));
    dispatch(logOut());
  }
};

export {
  loginAction,
  logoutAction,
  authCheckState,
  request, 
  success,
  error
};



// WEBPACK FOOTER //
// ./src/store/auth/action.js